import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { toAppError } from './errors';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts a human-readable error message from an unknown error.
 * Delegates to toAppError for consistent message extraction across the app.
 */
export function getErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  const appError = toAppError(error);
  return appError.userMessage || fallback;
}

export function formatPaise(paise: number): string {
  return `₹${(paise / 100).toLocaleString('en-IN')}`;
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
